export default "images/space.png";